import React, { Component } from "react";

import 'assets/scss/landingPage.css';

class SocialIcons extends Component {
  handleSubmit = (e) => {
    e.preventDefault();
    const { handleClick, subscribe } = this.props;
    handleClick();
    subscribe();
  }

  render() {

    return (
      <ul className="footer-social-icons">
        <li><a className="footer-icon facebook-icon" target="_blank" href="https://www.facebook.com/MySoonoCX"></a></li>
        <li><a className="footer-icon instagram-icon" target="_blank" href="https://www.instagram.com/mysoono"></a></li>
        <li><a className="footer-icon linkedin-icon" target="_blank" href="https://www.linkedin.com/company/soono/"></a></li>
        <li><a className="footer-icon twitter-icon" target="_blank" href="https://twitter.com/MySoonoCX"></a></li>
      </ul>
    );
  }
}

export default SocialIcons;



// WEBPACK FOOTER //
// ./src/components/LandingPage/SocialIcons.js